import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from "react-icons/md";
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ViewWarehouse from '../../../../component/b2c/models/ViewWarehouse';
import { useMyContext } from '../../../../context/MyContext';
import Swal from 'sweetalert2';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../../css/custom-scrollbar.css';
import { LuWarehouse, LuMapPin, LuPhone, LuBoxes, LuPackageSearch } from "react-icons/lu";
import axios from 'axios';
import { CgSearch } from "react-icons/cg";
import { Base_Url, deletewarehouse, Warehouselist } from '../../../../config/config';

const AllWarehouses = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  // const [selectAll, setSelectAll] = useState(false);
  const { isToggleSidebar } = useMyContext();
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const navigate = useNavigate();
  const [loadingWarehouseId, setloadingWarehouseId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetchWarehouses()
  }, [page, limit]);


  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const urlWarehouse = `${Base_Url}${Warehouselist}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(urlWarehouse, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS" && Array.isArray(result.data)) {
        setWarehouses(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
        console.error('Unexpected response format:', result);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };


  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = warehouses.slice(indexOfFirstItem, indexOfLastItem);

  const handleViewClick = (warehouse) => {
    setSelectedWarehouse(warehouse);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
    // Show SweetAlert confirmation dialog
    setloadingWarehouseId(id);
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      // Only proceed with deletion if user confirms
      if (result.isConfirmed) {
        const urldelete = Base_Url + deletewarehouse;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            warehouseId: id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            setWarehouses((prevWarehouses) => prevWarehouses.filter(warehouse => warehouse.id !== id));
            setTotalOrders((prev) => prev - 1);

            // Show success message using SweetAlert
            Swal.fire(
              'Deleted!',
              response.data.message || 'Warehouse has been deleted successfully.',
              'success'
            );
          } else {
            // Show error message using SweetAlert
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
          setloadingWarehouseId(null);
        } catch (error) {
          // Show error message using SweetAlert
          Swal.fire(
            'Error!',
            'Error deleting warehouse: ' + error.message,
            'error'
          );
        }
      }
    });
  };


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


  const getFilteredWarehouse = () => {
    if (!searchTerm.trim()) {
      return warehouses;
    }

    const term = searchTerm.toLowerCase();
    return warehouses.filter(warehouse => {
      return (
        // Make sure to handle potential undefined values with optional chaining
        (warehouse.name?.toString().toLowerCase().includes(term)) ||
        (warehouse.phone?.toLowerCase().includes(term)) ||
        (warehouse.id?.toString().toLowerCase().includes(term))
      );
    });
  };

  const displayWarehouses = getFilteredWarehouse();

  // Derived, display-only counts (does not change fetching/pagination logic)
  const activeOnPage = warehouses.filter(w => w.status === 'Active' || !w.status).length;
  const inactiveOnPage = warehouses.filter(w => w.status === 'Inactive').length;

  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-slate-50'}`}>
        <div className="z-10">
          <NavBar />
        </div>

        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
              style={
                window.innerWidth < 768
                  ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                  : {}
              }>
              <Sidebar />
            </div>
          )}

          <div className={`overflow-x-hidden  mb-2  w-full  overflow-y-auto p-4 sm:p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : 'bg-gray-200'}`}>

            {/* Page header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-2">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-11 h-11 rounded-2xl bg-gradient-to-br from-indigo-600 to-violet-600 shadow-lg shadow-indigo-500/25 flex-shrink-0">
                  <LuWarehouse className="text-white" size={22} />
                </div>
                <div>
                  <h1 className="text-lg sm:text-xl font-bold text-slate-800 dark:text-white leading-tight">
                    All Warehouses
                  </h1>
                  <p className="text-xs text-slate-500 dark:text-gray-400">
                    Manage every registered warehouse location
                  </p>
                </div>
              </div>
              <div className="flex min-w-[250px] items-center gap-3 rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-darkmodeColor p-4 shadow-sm">
                <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 flex-shrink-0">
                  <LuBoxes size={18} />
                </div>
                <div>
                  <p className="text-xs text-slate-400 dark:text-gray-400 font-medium">Total Warehouses</p>
                  <p className="text-lg font-bold text-slate-800 dark:text-white">{totalOrders}</p>
                </div>
              </div>
            </div>

            {/* Stat cards */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">

              {/* 
              <div className="flex items-center gap-3 rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-darkmodeColor p-4 shadow-sm">
                <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 flex-shrink-0">
                  <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse" />
                </div>
                <div>
                  <p className="text-xs text-slate-400 dark:text-gray-400 font-medium">Active (this page)</p>
                  <p className="text-lg font-bold text-slate-800 dark:text-white">{activeOnPage}</p>
                </div>
              </div> */}

              {/* <div className="flex items-center gap-3 rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-darkmodeColor p-4 shadow-sm">
                <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-rose-50 dark:bg-rose-500/10 text-rose-600 dark:text-rose-400 flex-shrink-0">
                  <span className="w-2.5 h-2.5 rounded-full bg-rose-500" />
                </div>
                <div>
                  <p className="text-xs text-slate-400 dark:text-gray-400 font-medium">Inactive (this page)</p>
                  <p className="text-lg font-bold text-slate-800 dark:text-white">{inactiveOnPage}</p>
                </div>
              </div> */}
            </div>

            {/* Search bar */}
            <div className="mb-2">
              <div className="relative group max-w-full">
                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-violet-500/10 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                <div className="relative flex items-center bg-white dark:bg-darkmodeColor border border-slate-200 dark:border-gray-700 rounded-2xl shadow-sm hover:shadow-md focus-within:shadow-md focus-within:border-indigo-400 transition-all duration-300">
                  <div className="pl-4 pr-3">
                    <CgSearch className="text-slate-400 dark:text-gray-300 transition-colors duration-200 group-focus-within:text-indigo-500" size={19} />
                  </div>

                  <input
                    type="text"
                    placeholder="Search by ID, phone or name"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="flex-1 py-3 pr-3 bg-transparent outline-none dark:text-white text-slate-700 placeholder-slate-400 dark:placeholder-gray-400 text-sm"
                  />

                  {searchTerm && (
                    <button
                      onClick={() => handleSearchChange({ target: { value: '' } })}
                      className="mr-3 p-1.5 text-slate-400 hover:text-rose-500 dark:hover:text-rose-400 transition-colors duration-200 rounded-full hover:bg-rose-50 dark:hover:bg-rose-900/20"
                    >
                      <span className="sr-only">Clear search</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="rounded-2xl border border-slate-500 dark:border-gray-700 bg-white dark:bg-darkmodeColor shadow-sm overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full table-auto">
                  <thead className="bg-gray-500 border-b border-slate-500 dark:bg-[#0b1233] text-white dark:text-gray-300 text-[11px] uppercase tracking-wide">
                    <tr>
                      <th className="p-3 text-left font-semibold">Warehouse</th>
                      <th className="p-3 text-left font-semibold">Contact</th>
                      <th className="p-3 text-left font-semibold">Location</th>
                      <th className="p-3 text-left font-semibold">Status</th>
                      <th className="p-3 text-right font-semibold">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 dark:divide-gray-700">
                    {displayWarehouses.length === 0 ? (
                      <tr>
                        <td colSpan={5} className="p-10">
                          <div className="flex flex-col items-center justify-center text-center gap-2">
                            <div className="flex items-center justify-center w-12 h-12 rounded-2xl bg-slate-100 dark:bg-gray-800 text-slate-400 dark:text-gray-500">
                              <LuPackageSearch size={22} />
                            </div>
                            <p className="text-sm font-semibold text-slate-600 dark:text-gray-300">
                              No warehouses found
                            </p>
                            <p className="text-xs text-slate-400 dark:text-gray-500">
                              Try adjusting your search term.
                            </p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      displayWarehouses.map((warehouse) => (
                        <tr
                          key={warehouse.id}
                          className="hover:bg-slate-50 dark:hover:bg-gray-800/60 transition-colors duration-150"
                        >
                          <td className="p-3">
                            <div className="flex items-center gap-3">
                              <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 text-white text-xs font-bold flex-shrink-0">
                                {warehouse.name?.toString().charAt(0).toUpperCase() || 'W'}
                              </div>
                              <div className="min-w-0">
                                <p className="text-sm font-semibold text-slate-800 dark:text-white truncate">
                                  {warehouse.name}
                                </p>
                                <p className="text-[11px] text-slate-400 dark:text-gray-400">
                                  ID: {warehouse.id}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td className="p-3">
                            <p className="text-xs text-slate-600 dark:text-gray-300 truncate max-w-[180px]">
                              {warehouse.email}
                            </p>
                            <p className="flex items-center gap-1 text-[11px] text-slate-400 dark:text-gray-400 font-mono mt-0.5">
                              <LuPhone size={12} />
                              {warehouse.phone}
                            </p>
                          </td>
                          <td className="p-3">
                            <p className="flex items-center gap-1 text-xs text-slate-600 dark:text-gray-300">
                              <LuMapPin size={13} className="text-slate-400 flex-shrink-0" />
                              {[warehouse.city, warehouse.state, warehouse.country].filter(Boolean).join(', ')}
                            </p>
                          </td>
                          <td className="p-3">
                            <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium ${warehouse.status === 'Active'
                              ? 'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400'
                              : warehouse.status === 'Inactive'
                                ? 'bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-400'
                                : 'bg-slate-100 text-slate-500 dark:bg-gray-800 dark:text-gray-400'
                              }`}>
                              <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${warehouse.status === 'Active'
                                ? 'bg-emerald-500 animate-pulse'
                                : warehouse.status === 'Inactive'
                                  ? 'bg-rose-500'
                                  : 'bg-slate-400'
                                }`}></span>
                              {warehouse.status || 'Active'}
                            </span>
                          </td>
                          <td className="p-3">
                            <div className="flex items-center justify-end gap-2">
                              <Button
                                onClick={() => handleViewClick(warehouse)}
                                aria-label="View warehouse"
                                sx={{
                                  minWidth: 0,
                                  width: 32,
                                  height: 32,
                                  borderRadius: '10px',
                                  backgroundColor: '#eef2ff',
                                  color: '#4f46e5',
                                  boxShadow: 'none',
                                  '&:hover': { backgroundColor: '#e0e7ff', boxShadow: 'none' }
                                }}
                              >
                                <IoMdEye size={16} />
                              </Button>
                              <Button
                                onClick={() => handleDelete(warehouse.id)}
                                aria-label="Delete warehouse"
                                disabled={loadingWarehouseId === warehouse.id}
                                sx={{
                                  minWidth: 0,
                                  width: 32,
                                  height: 32,
                                  borderRadius: '10px',
                                  backgroundColor: '#fef2f2',
                                  color: '#e11d48',
                                  boxShadow: 'none',
                                  '&:hover': { backgroundColor: '#fee2e2', boxShadow: 'none' }
                                }}
                              >
                                {loadingWarehouseId === warehouse.id ? (
                                  <span className="animate-spin text-sm">⏳</span>
                                ) : (
                                  <MdDelete size={16} />
                                )}
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Footer: count, page size, pagination */}
              <div className="flex flex-col sm:flex-row justify-between items-center gap-3 px-4 py-3 border-t border-slate-100 dark:border-gray-700">
                <span className="text-xs text-slate-500 dark:text-gray-400 font-medium">
                  {`Total Warehouses: ${totalOrders}`}
                </span>

                <div className="flex items-center gap-3">
                  <select
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                    className={`border border-slate-200 dark:border-gray-700 rounded-lg px-2 py-1.5 text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 outline-none focus:border-indigo-400 ${totalOrders < 10 ? 'cursor-not-allowed opacity-50' : ''}`}
                    disabled={totalOrders < 10}
                  >
                    {totalOrders === 0 ? (
                      <option value={0}>0</option>
                    ) : (
                      <>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={totalOrders}>All</option>
                      </>
                    )}
                  </select>

                  <Pagination
                    count={Math.ceil(totalOrders / limit)}
                    page={currentPage}
                    onChange={handlePaginationChange}
                    variant="outlined"
                    shape="rounded"
                    size="small"
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        sx={{
                          borderRadius: '8px',
                          '&.Mui-selected': {
                            backgroundColor: '#4f46e5',
                            color: '#fff',
                            borderColor: '#4f46e5',
                            '&:hover': { backgroundColor: '#4338ca' }
                          }
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <ViewWarehouse isopen={isPopupOpen} onClose={handleClose} warehouse={selectedWarehouse} />
      </div>
    </>
  );
};

export default AllWarehouses;